import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    linkId = '',
    password = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utableShare.getShareTableForm, {
        linkId,
        password,
    }, options);
    if (error) return { error, status };
    return content || {};
};
